import { CaseDocumentAdmin } from "custom-models";

import { shallowLeftDiff } from "shared/utils/formUtils";

export const submissionFieldsForDocument = (
  _document: CaseDocumentAdmin,
  values?: Partial<CaseDocumentAdmin>
) => {
  if (!values) values = _document;

  return {
    case_id: values.case ? values.case.id : _document.case_id,
    case__accession: values.case
      ? values.case.accession
      : _document.case__accession,
    category: values.category || null,
    status: values.status || null,
    name: values.name || null,
  };
};

export const shallowDocumentComparison = (
  _document: CaseDocumentAdmin,
  values: Partial<CaseDocumentAdmin>
) => {
  const oldValues = submissionFieldsForDocument(_document);
  const newValues = submissionFieldsForDocument(_document, values);

  return shallowLeftDiff<ReturnType<typeof submissionFieldsForDocument>>(
    oldValues,
    newValues
  );
};
